import angular from 'angular';

export default angular.module('cms.creator.clickOutside', [])
  .service('ClickOutside', function ($document) {

    const KEY_ATTR = 'click-outside-element-uid';

    this.setCurrent = (keyValue, callbackFn, ignore) => {
      this.currentKey = keyValue;
      this.callback = callbackFn;
      this.ignoreClass = ignore;
    };

    this.clear = () => {
      if(this.currentKey && this.callback)  {
        this.callback();
      }
      this.setCurrent(null);
    };

    let isIgnoredElement = (element) => {
      if(!element.className) {
        return false;
      }

      if(this.ignoreClass && element.className.toString().indexOf(this.ignoreClass) !== -1) {
        return true;
      }

      return element.id === 'ckeditorToolbarContainer' ||
             element.className.toString().indexOf('ui-select-choices') !== -1 ||
             element.className.toString().indexOf('modal') !== -1 ||
             element.className.toString().indexOf('modal-backdrop') !== -1 ||
             element.className.toString().indexOf('shepherd') !== -1;
    };

    let handler = (e) => {

      if(!this.currentKey) {
        return;
      }

      for (let element = e.target; element; element = element.parentNode) {
        if (element.attributes) {
          if (element.getAttribute(KEY_ATTR) === this.currentKey || isIgnoredElement(element)) {
            return;
          }
        }
      }

      this.currentKey = null;
      return this.callback();
    };

    $document.on('click', handler);

    return {
      setCurrent: this.setCurrent,
      clear: this.clear
    };

  }).name


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Workspace/ClickOutside/ClickOutsideService.js